<template>
  <Layout>
    <!-- 面包屑 -->
    <div class="w-full bg-gray-100 py-3">
      <div class="max-w-6xl mx-auto px-4 lg:px-8">
        <ol class="flex items-center text-sm text-gray-500">
          <li><router-link to="/" class="hover:text-primary">Home</router-link></li>
          <li class="before:content-['/'] before:mx-2 text-gray-800">Contact Us</li>
        </ol>
      </div>
    </div>

    <div class="w-full max-w-6xl mx-auto px-4 lg:px-8 py-6">
      <div class="flex flex-col lg:flex-row gap-8">
        <div class="lg:w-52 flex-shrink-0">
          <ul class="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden">
            <li
              v-for="(tab, index) in tabList"
              :key="index"
              :class="['cursor-pointer px-4 py-3 text-sm border-b border-gray-100 last:border-b-0 hover:bg-gray-50 transition-colors', { 'bg-primary text-white font-medium': tabIndex === index }]"
              @click="changeTab(index, tab.typeName)">
              <span>{{ tab.menuName }}</span>
            </li>
          </ul>
        </div>

        <div class="flex-1 min-w-0">
          <div class="bg-white border border-gray-200 rounded-lg shadow-sm p-6">
            <h2 class="text-lg font-bold text-gray-800 mb-3">Get catalog and quote</h2>
            <div class="border-t border-gray-200 mb-5"></div>

            <div class="space-y-4">
              <div class="flex flex-col sm:flex-row sm:items-center">
                <label class="sm:w-36 text-sm text-gray-700 mb-1 sm:mb-0 shrink-0">Name</label>
                <input type="text" class="w-full border border-gray-300 rounded-lg px-3 py-2 min-h-[44px] focus:border-blue-400 focus:outline-none" v-model="formData.name" placeholder="">
              </div>

              <div class="flex flex-col sm:flex-row sm:items-center">
                <label class="sm:w-36 text-sm text-red-500 mb-1 sm:mb-0 shrink-0">* Email</label>
                <input type="email" class="w-full border border-gray-300 rounded-lg px-3 py-2 min-h-[44px] focus:border-blue-400 focus:outline-none" v-model="formData.email" placeholder="We will send quotation to this email">
              </div>

              <div class="flex flex-col sm:flex-row sm:items-center">
                <label class="sm:w-36 text-sm text-red-500 mb-1 sm:mb-0 shrink-0">* Phone No.</label>
                <input type="tel" class="w-full border border-gray-300 rounded-lg px-3 py-2 min-h-[44px] focus:border-blue-400 focus:outline-none" v-model="formData.phone" placeholder="We will discuss details over WhatsApp">
              </div>

              <div class="flex flex-col sm:flex-row sm:items-center">
                <label class="sm:w-36 text-sm text-gray-700 mb-1 sm:mb-0 shrink-0">Company</label>
                <input type="text" class="w-full border border-gray-300 rounded-lg px-3 py-2 min-h-[44px] focus:border-blue-400 focus:outline-none" v-model="formData.company" placeholder="Company or Business Name">
              </div>

              <div class="flex flex-col sm:flex-row sm:items-start">
                <label class="sm:w-36 text-sm text-gray-700 mb-1 sm:mb-0 pt-2 shrink-0">Message</label>
                <textarea class="w-full border border-gray-300 rounded-lg px-3 py-2 min-h-[100px] resize-y focus:border-blue-400 focus:outline-none" v-model="formData.message" placeholder="Please tell us your needs"></textarea>
              </div>

              <div class="flex sm:pl-36">
                <button class="bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 px-10 rounded-lg transition-colors" @click="submitQuotation">Submit</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/components/common/CommonLayout";

export default {
  name: "NewsView",
  components: {Layout},
  data() {
    return {
      articles: {},
      pageIndex: 1,
      tabIndex: 0,
      formData: {
        name: '',
        email: '',
        phone: '',
        company: '',
        message: ''
      },
      tabList: [
        {typeId: 0, typeName: 'details', menuName: 'Leave your message'},
      ],
    }
  },
  mounted() {
    // this.getArticle(1)
  },
  methods: {
    changeIndex(p) {
      if (p === 0) {
        this.pageIndex = 1
      } else if (p === this.articles.pages + 1) {
        this.pageIndex = this.articles.pages
      } else {
        this.pageIndex = p;
        this.getArticle(p)
      }
    },
    submitQuotation() {
      if (!this.formData.email) {
        alert('Email is required')
        return
      }
      this.postRequest("/api/inquiries", this.formData).then(resp => {
        if (resp && resp.data && resp.data.code === 200) {
          alert('Submit successfully! We will contact you soon.')
          this.formData = { name: '', email: '', phone: '', company: '', message: '' }
        } else {
          alert('Submit failed, please try again.')
        }
      }).catch(() => {
        alert('Network error, please try again later.')
      })
    }
  }
}
</script>

